export default 'M20 0a2 2 0 0 1 2 2v20a2 2 0 0 1-4 0V2c0-1.1.9-2 2-2m-8.83 12L2.6 3.41A2 2 0 1 1 5.4.6L16.83 12 5.4 23.41a2 2 0 0 1-2.82 0 2 2 0 0 1 0-2.82z';